import oauth2ClientsRoutes from "./oauth2-clients/routes";
import usersRoutes from "./users/routes";
import { IMenu, IRoute, RenderRoutes } from "@src/routes";
import { NavBar } from "@funcional/react-ui";
import { SsoRolesEnum } from "@funcional/react-auth-ui";
import { Redirect } from "react-router-dom";

const menus: IMenu[] = [
  {
    label: "Single Sign On",
    path: "/sso",
    roles: [SsoRolesEnum.MASTER],
    routes: [
      {
        label: "Usuários SSO",
        path: "/sso/users",
        roles: [SsoRolesEnum.MASTER],
      },
      {
        label: "Clientes OAuth2",
        path: "/sso/oauth2-clients",
        roles: [SsoRolesEnum.MASTER],
      },
    ],
  },
];

const routes: IRoute[] = [
  {
    menu: { label: "Usuários SSO" },
    path: "/sso",
    key: "USERS",
    component: (props: any) => (
      <div className="flex w-full">
        <NavBar menus={menus} />
        <div className="p-8 overflow-x-hidden overflow-y-auto md:flex-1">
          <RenderRoutes {...props} />
        </div>
      </div>
    ),
    routes: [
      {
        path: "/sso/",
        key: "USERS_ROOT",
        exact: true,
        roles: [SsoRolesEnum.MASTER],
        component: () => <Redirect to="/sso/users" />,
      },
      ...usersRoutes,
      ...oauth2ClientsRoutes,
    ],
  },
];

export default routes;
